import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Jurisdiction } from '@/modules/predefined/models/Jurisdiction';

export class ContentSourceJurisdiction extends BaseEntityModel {
  id?: number;
  contentSourceId?: number;
  jurisdictionId?: number;
  jurisdiction: Relationship<Jurisdiction | null>;

  constructor(model: Partial<ContentSourceJurisdiction> = {}) {
    super(model);

    this.id = model.id;
    this.contentSourceId = model.contentSourceId;
    this.jurisdictionId = model.jurisdictionId;
    this.jurisdiction = Jurisdiction.mapModelOrNull(model.jurisdiction);
  }
}
